import apiClient from './client';

export type FeedbackType = 'ERRATA' | 'SUGGESTION' | 'OTHER';

export interface RawFeedbackItem {
  id: string;
  materialid: string;
  materialtitle: string;
  content: string;
  feedbacktype: FeedbackType;
  status: number;
  submittime: number;
  processtime?: number | null;
  processremark?: string;
}

export interface FeedbackItem {
  id: string;
  materialId: string;
  materialTitle: string;
  content: string;
  feedbackType: FeedbackType;
  status: number;
  submitTime: number;
  processTime?: number | null;
  processRemark?: string;
}

export function normalizeFeedbackItem(raw: RawFeedbackItem): FeedbackItem {
  return {
    id: raw.id,
    materialId: raw.materialid,
    materialTitle: raw.materialtitle,
    content: raw.content,
    feedbackType: raw.feedbacktype,
    status: raw.status,
    submitTime: raw.submittime,
    processTime: raw.processtime,
    processRemark: raw.processremark,
  };
}

const FEEDBACK_TYPE_LABELS: Record<FeedbackType, string> = {
  ERRATA: 'Errata',
  SUGGESTION: 'Suggestion',
  OTHER: 'Other',
};

export function feedbackTypeLabel(type: FeedbackType): string {
  return FEEDBACK_TYPE_LABELS[type] ?? type;
}

export async function submitFeedback(params: {
  materialId: string;
  content: string;
  feedbackType?: FeedbackType;
}): Promise<{ id: string }> {
  const p = new URLSearchParams();
  p.append('materialId', params.materialId);
  p.append('content', params.content);
  if (params.feedbackType) p.append('feedbackType', params.feedbackType);
  const res = await apiClient.post('/agentfront/submitFeedback.htm', p);
  const d = res.data;
  if (d?.success) {
    const data = d.data as { id: string };
    return { id: data.id };
  }
  throw new Error(d?.info || 'Submit feedback failed');
}

export async function listMyFeedback(params?: {
  pageNumber?: number;
  pageSize?: number;
}): Promise<{ list: FeedbackItem[]; total: number; pageNumber: number; pageSize: number }> {
  const p = new URLSearchParams();
  if (params?.pageNumber) p.append('pageNumber', String(params.pageNumber));
  if (params?.pageSize) p.append('pageSize', String(params.pageSize));
  const res = await apiClient.post('/agentfront/listMyFeedback.htm', p);
  const d = res.data;
  if (d?.success) {
    const raw = d.data as {
      list: RawFeedbackItem[];
      total: number;
      pageNumber: number;
      pageSize: number;
    };
    return {
      list: (raw.list ?? []).map(normalizeFeedbackItem),
      total: raw.total,
      pageNumber: raw.pageNumber,
      pageSize: raw.pageSize,
    };
  }
  throw new Error(d?.info || 'Load feedback failed');
}
